import React from 'react';
import { List } from '../../../Generic';

export default function ModuleGoal() {
  const list = [
    'Comprendre les risques de sécurité actuels',
    "Identifier les faiblesses d'un système d'information",
    'Implémenter des mécanismes de sécurité concrets',
    "Identifier l'origine d'une attaque (forensic)",
    'Maîtriser les outils de cybersécurité professionnels'
  ];

  return (
    <>
      <h1>
        <span className="white">Objectifs du module</span>
      </h1>
      <List list={list} />

      <div style={{ marginTop: '40px', textAlign: 'center' }}>
        <h3 style={{ color: '#4ecdc4' }}>
          <span role="img" aria-label="Target">
            🎯
          </span>{' '}
          <strong>À la fin de ce module, vous serez capables de :</strong>
        </h3>
        <p style={{ fontSize: '1.2em', color: 'white' }}>
          Analyser, sécuriser et défendre des infrastructures réelles
        </p>
      </div>
    </>
  );
}
